import { Link } from "react-router-dom";
import { Logo } from "@/components/comiq/Logo";
import { Eyebrow } from "@/components/comiq/Eyebrow";
import { Contour } from "@/components/comiq/Contour";
import { COLORS } from "@/comiq/tokens";
import { Clock, ListChecks, ShieldCheck, Save, ArrowRight, Building2 } from "lucide-react";

const facts = [
  { icon: Clock, label: "± 11 menit", sub: "Bisa dijeda kapan saja" },
  { icon: ListChecks, label: "24 pertanyaan", sub: "4 domain kapabilitas" },
  { icon: Save, label: "Tersimpan otomatis", sub: "Lanjutkan dari mana pun" },
  { icon: ShieldCheck, label: "Rahasia", sub: "Laporan bersifat agregat" },
];

export default function RespondentIntro() {
  return (
    <div className="min-h-screen" style={{ background: COLORS.paper }}>
      {/* Restrained header */}
      <header className="border-b" style={{ borderColor: COLORS.line }}>
        <div className="mx-auto flex max-w-3xl items-center justify-between px-5 py-4">
          <Logo />
          <span className="text-xs font-medium" style={{ color: COLORS.textSoft }}>Undangan Survei</span>
        </div>
      </header>

      <main className="relative overflow-hidden">
        {/* Decorative contour kept away from reading content, top-right */}
        <Contour className="pointer-events-none absolute -right-16 top-0 hidden h-72 w-[460px] opacity-80 md:block" />

        <div className="mx-auto max-w-reading px-5 py-12 sm:py-16">
          {/* Recognized organization banner */}
          <div className="mb-8">
            <div
              data-testid="org-banner"
              className="inline-flex items-center gap-2.5 rounded-full border px-4 py-2 text-sm"
              style={{ borderColor: COLORS.line, background: COLORS.surfaceAlt, color: COLORS.ink }}
            >
              <Building2 size={16} style={{ color: COLORS.orangeInk }} />
              Diundang oleh <strong className="font-semibold">PT Nusantara Commercial</strong>
            </div>
          </div>

          <Eyebrow>ComIQ Commercial Talent Study · Gelombang 2026</Eyebrow>
          <h1 className="font-serif-editorial mt-4 text-4xl sm:text-5xl" style={{ color: COLORS.ink }}>
            Bantu kami memahami cara Anda <em>bekerja & berpikir</em> secara komersial.
          </h1>
          <p className="mt-5 text-base sm:text-lg" style={{ color: COLORS.textSoft, lineHeight: 1.6 }}>
            Ini bukan ujian dan tidak ada jawaban benar atau salah. Jawablah sejujur dan sespontan mungkin —
            justru itu yang membuat hasilnya bermakna bagi Anda dan organisasi.
          </p>

          {/* Fact chips */}
          <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
            {facts.map((f) => (
              <div
                key={f.label}
                className="rounded-comiq border bg-comiq-surface-alt p-4"
                style={{ borderColor: COLORS.line }}
              >
                <f.icon size={18} style={{ color: COLORS.orangeInk }} />
                <div className="mt-2.5 text-sm font-semibold" style={{ color: COLORS.ink }}>{f.label}</div>
                <div className="text-xs" style={{ color: COLORS.textSoft }}>{f.sub}</div>
              </div>
            ))}
          </div>

          {/* What to expect */}
          <div className="mt-10 rounded-comiq-lg border p-6" style={{ borderColor: COLORS.line, background: COLORS.surface }}>
            <h2 className="text-lg font-semibold" style={{ color: COLORS.ink }}>Yang akan Anda temui</h2>
            <ul className="mt-4 space-y-3">
              {[
                "Pernyataan singkat yang dinilai pada skala 1–5.",
                "Bila sebuah pernyataan belum terpikirkan, ada pilihan “Tidak yakin / belum terpikirkan”.",
                "Kemajuan Anda tersimpan otomatis — tautan ini mengenali Anda saat kembali.",
              ].map((t, i) => (
                <li key={i} className="flex gap-3 text-sm" style={{ color: COLORS.textSoft }}>
                  <span
                    className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-xs font-bold"
                    style={{ background: "rgba(242,84,27,0.12)", color: COLORS.orangeInk }}
                  >
                    {i + 1}
                  </span>
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Confidentiality */}
          <p className="mt-6 flex items-start gap-2 text-sm" style={{ color: COLORS.textSoft }}>
            <ShieldCheck size={16} className="mt-0.5 shrink-0" style={{ color: COLORS.orangeInk }} />
            Identitas Anda hanya terlihat oleh admin ComIQ yang berwenang. Laporan ke perusahaan selalu ditampilkan secara agregat.
          </p>

          {/* CTA */}
          <div className="mt-9 flex flex-col items-start gap-3 sm:flex-row sm:items-center">
            <Link to="/preview/question" className="btn-comiq btn-accent" data-testid="start-survey-btn">
              Mulai Survei <ArrowRight size={16} />
            </Link>
            <span className="text-xs" style={{ color: COLORS.textSoft }}>Dengan melanjutkan, Anda menyetujui pemrosesan jawaban sesuai kebijakan privasi ComIQ.</span>
          </div>
        </div>
      </main>
    </div>
  );
}
